import React, { useState, useRef, useEffect } from "react";

import DropDownIcon from "../../Assets/Images/CreateBatch/icon-dropdown-menu.png";

export default function DropDown({
  width,
  label,
  selected,
  setSelected,
  options,
  customWidth,
  customTop,
  isRequired,
  style,
  className, // Add this line
}) {
  const [isActive, setIsActive] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState("");
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsActive(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  const handleClick = (option) => {
    setSelected(option.id); // Pass the ID of the selected option
    setIsActive(false);
    console.log("Selected option ID:", option.id); // Log the ID of the selected option
    setSelectedLabel(option.label);
  };

  return (
    <div className={`dropdown-CB ${className}`} style={{ width , ...style }} ref={dropdownRef}>
      <label className="dropdown-CB-label">
        {label}
        {isRequired && <span>*</span>}
      </label>
      <div className="dropdown-btn" onClick={() => setIsActive(!isActive)}>
        {selectedLabel}
        <img src={DropDownIcon} alt="dropdown-icon" />
      </div>
      {isActive && (
        <div
          className="dropdown-content-CBV2"
          style={{ width: customWidth, top: customTop }}
        >
          {options.map((option) => (
            <div
              key={option.id}
              className="dropdown-item-CBV2"
              onClick={() => handleClick(option)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
